@let canModifyThemeValue = canModifyTheme();

<itc-toggle-panel
  iconClass="fa-regular fa-circle-half-stroke"
  [label]="'header.theme' | translate"
  [attr.aria-disabled]="!canModifyThemeValue"
  [class.theme-toggle-panel--readonly]="!canModifyThemeValue"
  [kdsTooltip]="'general.missing-permission' | translate"
  [disableTooltip]="canModifyThemeValue"
  [disabled]="!canModifyThemeValue"
>
  <itc-theme-options-toggle-list />
</itc-toggle-panel>
